import { useState, useLayoutEffect } from "react";
import useIsMobileViewport from "./use-is-mobile-viewport";

type DeviceClass = "mobile" | "non-mobile";

const getTodoViewStorageKey = (deviceClass: DeviceClass) => `todo-view-open-${deviceClass}`;

/**
 * Hook to manage todo view open/closed state per device class
 * Defaults to open state and persists preference in localStorage
 */
export const useTodoViewPreferences = () => {
    const { isMobileViewport: isMobile } = useIsMobileViewport();
    const deviceClass: DeviceClass = isMobile ? "mobile" : "non-mobile";
    const storageKey = getTodoViewStorageKey(deviceClass);

    const [isOpen, setIsOpen] = useState(() => {
        const savedState = localStorage.getItem(storageKey);
        return savedState !== null ? savedState === "true" : true; // Default to open
    });

    const setTodoViewOpen = (open: boolean) => {
        setIsOpen(open);
        localStorage.setItem(storageKey, open.toString());
    };

    useLayoutEffect(() => {
        // Update state when device class changes (e.g., window resize)
        const savedState = localStorage.getItem(storageKey);
        const newState = savedState !== null ? savedState === "true" : true;
        setIsOpen(newState);
    }, [storageKey]);

    return {
        isOpen,
        setIsOpen: setTodoViewOpen,
        deviceClass,
    };
};
